const it = {
  brand: "E2 Care",
  tagline: "Assistenza calma e connessa.",
  nav_dashboard: "Dashboard",
  nav_residents: "Pazienti",
  nav_patients: "Pazienti",
  nav_rooms: "Stanze",
  nav_devices: "Dispositivi",
  nav_events: "Eventi",
  nav_alerts: "Avvisi",
  nav_users: "Team",
  nav_settings: "Impostazioni",
  nav_admin: "Amministrazione",
  nav_signout: "Esci",
  topbar_search_placeholder: "Cerca pazienti, stanze, dispositivi…",
  admin_super_only: "Solo i super-amministratori possono gestire le organizzazioni.",
  admin_admin_only: "Solo gli amministratori possono accedere a questa pagina.",
  admin_tab_orgs: "Organizzazioni",
  admin_tab_users: "Utenti",
  admin_tab_patients: "Pazienti",
  admin_tab_rooms: "Stanze",
  admin_tab_buildings: "Edifici",
  admin_tab_devices: "Dispositivi",
  admin_tab_alerts: "Avvisi",
  admin_tab_qa: "Strumenti di test",
  admin_delete: "Elimina",
  admin_no_orgs_yet: "Ancora nessuna organizzazione.",
  admin_field_name: "Nome",
  admin_field_email: "E-mail",
  admin_field_phone: "Telefono",
  admin_field_password: "Password",
  admin_field_role: "Ruolo",
  admin_field_type: "Tipo",
  admin_field_timezone: "Fuso orario",
  admin_field_address: "Indirizzo",
  admin_field_status: "Stato",
  admin_field_organization: "Organizzazione",
  admin_password_keep: "Lascia vuoto per mantenere",
  admin_field_birth_date: "Data di nascita",
  admin_field_room: "Stanza",
  admin_field_room_none: "Non assegnato",
  admin_field_photo: "URL foto",
  admin_field_photo_hint: "Incolla un URL pubblico — caricamento completo in v2.",
  admin_field_notes: "Note del caregiver",
  admin_field_emergency_contact: "Contatto di emergenza principale",
  admin_field_ec_name: "Nome",
  admin_field_ec_phone: "Telefono",
  admin_field_ec_relationship: "Relazione",
  admin_field_mac: "Indirizzo MAC",
  admin_field_firmware: "Firmware",
  admin_field_assignment: "Assegnato a",
  admin_field_assigned_room: "Stanza assegnata",
  admin_field_assigned_patient: "Paziente assegnato",
  admin_field_assigned_hint: "Opzionale. Sensori → stanza; braccialetti → paziente.",
  admin_field_sensor_target: "Montato su",
  admin_field_sensor_target_hint: "Indica al sistema se questo sensore controlla una porta o una finestra.",
  sensor_target_door: "Porta",
  sensor_target_window: "Finestra",
  sensor_target_unset: "Non configurato",
  admin_field_sensor_label: "Etichetta sensore",
  admin_field_sensor_label_hint: "Nome descrittivo mostrato in avvisi ed eventi — es. «Porta d’ingresso», «Finestra del bagno».",
  admin_field_building: "Edificio",
  admin_field_building_required: "Una stanza deve appartenere a un edificio.",
  room_openings: "Aperture",
  room_no_openings: "Nessun sensore di porta o finestra installato in questa stanza.",
  room_openings_summary: "{doors} {doorsLabel} · {windows} {windowsLabel}",
  opening_last_event: "Ultima variazione",
  admin_field_description: "Descrizione",
  admin_field_severity: "Gravità",
  admin_field_patient: "Paziente",
  admin_field_device: "Dispositivo",
  admin_field_message: "Messaggio",
  admin_orgs_title: "Organizzazioni",
  admin_orgs_sub: "Crea, modifica e archivia tenant di E2 Care.",
  admin_orgs_count: "organizzazioni",
  admin_org_new: "Nuova organizzazione",
  admin_org_new_title: "Nuova organizzazione",
  admin_org_edit_title: "Modifica organizzazione",
  admin_org_created: "Organizzazione creata.",
  admin_org_updated: "Organizzazione aggiornata.",
  admin_org_deleted: "Organizzazione archiviata.",
  admin_org_delete_title: "Archiviare l’organizzazione?",
  admin_org_delete_confirm: "«{name}» sarà nascosta dagli elenchi.",
  admin_users_title: "Utenti",
  admin_users_sub_super: "Gestisci ogni account utente su tutti i tenant.",
  admin_users_sub_org: "Gestisci account utenti di {org}.",
  admin_user_new: "Nuovo utente",
  admin_user_new_title: "Nuovo utente",
  admin_user_edit_title: "Modifica utente",
  admin_user_created: "Utente creato.",
  admin_user_updated: "Utente aggiornato.",
  admin_user_deleted: "Utente archiviato.",
  admin_user_delete_title: "Archiviare l’utente?",
  admin_user_delete_confirm: "«{name}» perderà l’accesso.",
  admin_user_memberships: "Appartenenze alle organizzazioni",
  admin_patients_title: "Pazienti",
  admin_patients_sub_super: "Gestisci tutti i pazienti su tutti i tenant.",
  admin_patients_sub_org: "Gestisci pazienti in {org}.",
  admin_patient_new: "Nuovo paziente",
  admin_patient_new_title: "Nuovo paziente",
  admin_patient_edit_title: "Modifica paziente",
  admin_patient_created: "Paziente creato.",
  admin_patient_updated: "Paziente aggiornato.",
  admin_patient_deleted: "Paziente archiviato.",
  admin_patient_delete_title: "Archiviare il paziente?",
  admin_patient_delete_confirm: "«{name}» sarà nascosto dagli elenchi.",
  admin_rooms_title: "Stanze",
  admin_rooms_sub_super: "Configura le stanze su tutti i tenant.",
  admin_rooms_sub_org: "Configura le stanze in {org}.",
  admin_room_new: "Nuova stanza",
  admin_room_new_title: "Nuova stanza",
  admin_room_edit_title: "Modifica stanza",
  admin_room_created: "Stanza creata.",
  admin_room_updated: "Stanza aggiornata.",
  admin_room_deleted: "Stanza archiviata.",
  admin_room_delete_title: "Archiviare la stanza?",
  admin_room_delete_confirm: "«{name}» sarà nascosta.",
  admin_devices_title: "Dispositivi",
  admin_devices_sub_super: "Configura i dispositivi Moko su tutti i tenant.",
  admin_devices_sub_org: "Configura i dispositivi Moko in {org}.",
  admin_device_new: "Nuovo dispositivo",
  admin_device_new_title: "Nuovo dispositivo",
  admin_device_edit_title: "Modifica dispositivo",
  admin_device_created: "Dispositivo creato.",
  admin_device_updated: "Dispositivo aggiornato.",
  admin_device_deleted: "Dispositivo archiviato.",
  admin_device_delete_title: "Archiviare il dispositivo?",
  admin_device_delete_confirm: "Il dispositivo {mac} sarà nascosto.",
  admin_buildings_title: "Edifici",
  admin_buildings_sub_super: "Raggruppa le stanze per edificio / ala su tutti i tenant.",
  admin_buildings_sub_org: "Raggruppa le stanze per edificio / ala in {org}.",
  admin_building_new: "Nuovo edificio",
  admin_building_new_title: "Nuovo edificio",
  admin_building_edit_title: "Modifica edificio",
  admin_building_created: "Edificio creato.",
  admin_building_updated: "Edificio aggiornato.",
  admin_building_deleted: "Edificio archiviato.",
  admin_building_delete_title: "Archiviare l’edificio?",
  admin_building_delete_confirm: "«{name}» sarà nascosto.",
  admin_qa_title: "Strumenti di test",
  admin_qa_sub: "Inietta eventi / avvisi per testare senza hardware Moko reale.",
  admin_qa_event_title: "Inietta evento di test",
  admin_qa_event_sub: "Simula un webhook Moko.",
  admin_qa_alert_title: "Inietta avviso di test",
  admin_qa_alert_sub: "Salta il livello eventi e scrive un avviso direttamente.",
  admin_qa_inject_event: "Inietta evento",
  admin_qa_inject_alert: "Inietta avviso",
  admin_qa_event_done: "Evento iniettato.",
  admin_qa_alert_done: "Avviso iniettato.",
  admin_qa_disclaimer: "Questi endpoint devono essere disabilitati in produzione.",
  admin_alerts_title: "Politica di avvisi",
  admin_alerts_sub: "Regole di avviso per l’intera {org}. Applicate a ogni paziente di questo tenant.",
  admin_alerts_quiet_title: "Ore di silenzio",
  admin_alerts_quiet_desc: "Definisci quando questa organizzazione è in «modalità notte». Utile per instradare gli avvisi non critici in modo più discreto.",
  admin_alerts_quiet_hint: "Gli orari sono interpretati nel fuso orario locale dell’organizzazione. L’intervallo può superare la mezzanotte (es. 22:00 → 06:00).",
  admin_alerts_night_start: "Inizio notte",
  admin_alerts_night_end: "Fine notte",
  admin_alerts_load_failed: "Carica politica di avvisi",
  admin_alerts_save_failed: "Salva politica di avvisi",
  admin_alerts_saved: "Politica di avvisi salvata.",
  admin_alerts_clear_title: "Cancella avvisi attivi",
  admin_alerts_clear_desc: "Conferma tutti gli avvisi aperti di questa organizzazione con un clic.",
  admin_alerts_clear_hint: "Utile dopo un’esercitazione pianificata o un sensore mal configurato che ha prodotto un’ondata di falsi positivi. Gli avvisi confermati restano nella cronologia.",
  admin_alerts_ack_all_button: "Conferma tutti",
  admin_alerts_ack_all_title: "Confermare tutti gli avvisi attivi?",
  admin_alerts_ack_all_confirm: "Ciò contrassegnerà come confermato ogni avviso aperto in {org}. Questa azione non può essere annullata.",
  admin_alerts_ack_all_done: "{count} avviso(i) confermato(i).",
  admin_alerts_ack_all_done_generic: "Tutti gli avvisi attivi confermati.",
  admin_alerts_ack_all_failed: "Conferma tutti gli avvisi",
  org_type_nursing_home: "Casa di riposo",
  org_type_assisted_living: "Residenza assistita",
  org_type_hospital: "Ospedale",
  org_type_home_care: "Assistenza domiciliare",
  role_admin: "Amministratore",
  role_caregiver: "Caregiver",
  role_family: "Famiglia",
  status_active: "attivo",
  status_inactive: "inattivo",
  confirm: "Conferma",
  sign_in: "Accedi",
  sign_up: "Registrati",
  email: "E-mail",
  password: "Password",
  full_name: "Nome completo",
  create_account: "Crea account",
  no_account: "Non hai un account?",
  have_account: "Hai già un account?",
  login_welcome: "Bentornato",
  login_sub: "Accedi per continuare a monitorare i tuoi residenti.",
  register_welcome: "Unisciti a E2 Care",
  register_sub: "Crea il tuo spazio di lavoro in meno di un minuto.",
  total_residents: "Pazienti",
  active_devices: "Dispositivi attivi",
  open_alerts: "Avvisi aperti",
  offline_gateways: "Dispositivi offline",
  falls_7d: "Cadute (7g)",
  sos_7d: "SOS (7g)",
  low_battery: "Batteria scarica",
  critical_residents: "Critici",
  status_ok: "Tutto bene",
  status_warning: "Attenzione",
  status_critical: "Critico",
  status_online: "Online",
  status_offline: "Offline",
  search: "Cerca",
  filter: "Filtra",
  all: "Tutti",
  refresh: "Aggiorna",
  loading: "Caricamento…",
  no_results: "Ancora nulla qui.",
  view_profile: "Visualizza profilo",
  showing_n_of_m: "Mostrando {n} di {m}",
  load_more: "Carica altro",
  auto_refresh: "Live · aggiornamento automatico",
  auto_refresh_paused: "In pausa (carica altro attivo)",
  updated_just_now: "Aggiornato ora",
  updated_n_sec_ago: "Aggiornato {n}s fa",
  updated_n_min_ago: "Aggiornato {n}m fa",
  acknowledge: "Conferma",
  acknowledged: "Confermato",
  ack_all: "Conferma tutti",
  ack_all_confirm: "Confermare i {count} avviso(i) attivo(i)?",
  ack_all_running: "Conferma in corso…",
  ack_all_done: "{count} avviso(i) confermato(i).",
  ack_all_partial: "{ok} confermato(i) · {fail} non riuscito(i).",
  last_seen: "Visto l’ultima volta",
  battery: "Batteria",
  signal: "Segnale",
  firmware: "Firmware",
  room: "App. / Stanza",
  age: "Età",
  emergency_contact: "Contatto di emergenza",
  notes: "Note",
  assigned_devices: "Dispositivi assegnati",
  recent_events: "Eventi recenti",
  timeline_24h: "Ultime 24 ore",
  delivery_status: "Stato consegna",
  acknowledged_by: "Confermato da",
  dashboard_title: "Panoramica",
  dashboard_sub: "Una rapida panoramica di tutto ciò che accade nelle case che assisti.",
  residents_title: "Pazienti",
  residents_sub: "Le persone che stai monitorando in questo momento.",
  devices_title: "Dispositivi",
  devices_sub: "Sensori e braccialetti.",
  devices_sub_admin: "Gateway, sensori e braccialetti.",
  events_title: "Eventi live",
  events_sub: "Flusso cronologico da ogni dispositivo connesso.",
  alerts_title: "Avvisi",
  alerts_sub: "Notifiche inoltrate a famiglia e caregiver.",
  settings_title: "Impostazioni",
  settings_sub: "Le tue preferenze e regole di notifica.",
  users_title: "Team",
  users_sub: "Caregiver, famiglia e amministratori con accesso.",
  falls_chart_title: "Cadute & SOS — ultimi 7 giorni",
  recent_alerts_title: "Avvisi critici recenti",
  no_alerts: "Nessun avviso aperto. Tutti sono al sicuro.",
  event_fall: "Caduta rilevata",
  event_sos: "Pulsante SOS premuto",
  event_door_open: "Porta aperta",
  event_door_close: "Porta chiusa",
  event_inactivity: "Inattività prolungata",
  event_low_battery: "Batteria scarica",
  event_offline: "Dispositivo offline",
  event_online: "Dispositivo di nuovo online",
  event_heartbeat: "Battito",
  event_button_press: "Pulsante premuto",
  device_gateway: "Gateway Bluetooth",
  device_door_sensor: "Sensore porta",
  device_bracelet: "Braccialetto",
  device_unknown: "Dispositivo sconosciuto",
  language: "Lingua",
  notifications: "Notifiche",
  quiet_hours: "Ore di silenzio",
  escalation: "Politica di escalation",
  just_now: "proprio ora",
  min_ago: "min fa",
  h_ago: "h fa",
  d_ago: "g fa",
  demo_hint: "Account demo: admin@e2care.lv / Care2024!",
  open_menu: "Apri menu",
  close_menu: "Chiudi menu",
  care_team: "Equipe di cura",
  family_members: "Famiglia",
  no_caregivers: "Nessun caregiver assegnato.",
  no_family: "Nessun familiare collegato.",
  add_caregiver: "Aggiungi caregiver",
  add_family: "Aggiungi familiare",
  select_user: "Seleziona un utente…",
  cancel: "Annulla",
  add: "Aggiungi",
  remove: "Rimuovi",
  save: "Salva",
  relationship: "Parentela",
  relationship_son: "Figlio",
  relationship_daughter: "Figlia",
  relationship_spouse: "Coniuge",
  relationship_other: "Altro",
  notify_via: "Notifica tramite",
  call_contact: "Chiama",
  view_resident: "Apri profilo",
  address: "Indirizzo",
  admin_only_section: "Strumenti admin",
  rooms_title: "Stanze",
  rooms_sub: "Ogni stanza che supervisioni — pazienti, dispositivi e stato attuale.",
  room_name: "Stanza",
  room_type: "Tipo",
  room_type_private_room: "Stanza privata",
  room_type_shared_room: "Stanza condivisa",
  room_type_apartment: "Appartamento",
  room_type_corridor: "Corridoio",
  room_type_common_area: "Area comune",
  room_floor: "Piano",
  room_state: "Stato attuale",
  door: "Porta",
  window: "Finestra",
  door_open_state: "Aperta",
  door_closed_state: "Chiusa",
  door_unknown_state: "Sconosciuto",
  room_no_devices: "Ancora nessun dispositivo in questa stanza.",
  room_no_patients: "Ancora nessun paziente assegnato a questa stanza.",
  room_patients: "Pazienti nella stanza",
  room_devices: "Dispositivi nella stanza",
  room_activity: "Cronologia attività",
  rooms_filter_all_types: "Tutti i tipi",
  widget_active_alerts: "Avvisi attivi",
  widget_active_alerts_sub: "Critici, non risolti e confermati",
  widget_patients_status: "Stato pazienti",
  widget_devices_health: "Stato dispositivi",
  widget_room_activity: "Attività stanze",
  widget_recent_events: "Feed eventi live",
  widget_connectivity: "Connettività",
  metric_critical: "Critico",
  metric_unresolved: "Non risolto",
  metric_acknowledged_count: "Confermati",
  metric_total: "Totale",
  metric_active: "Attivi",
  metric_online: "Online",
  metric_offline: "Offline",
  metric_ota_pending: "OTA in attesa",
  metric_battery_warn: "Batteria scarica",
  metric_doors_open: "Porte aperte",
  metric_windows_open: "Finestre aperte",
  metric_signal_avg: "Segnale medio",
  metric_last_comm: "Ultima com.",
  metric_packets: "Pacchetti / h",
  view_all: "Vedi tutto",
  status_new: "Nuovo",
  status_acknowledged: "Confermato",
  status_resolved: "Risolto",
  status_resolved_local: "Risolto (locale)",
  resolve: "Risolvi",
  add_note: "Aggiungi nota",
  save_note: "Salva nota",
  resolve_local_badge: "solo questo dispositivo",
  resolve_local_hint: "Contrassegna l’avviso come risolto solo nel tuo browser. Il server e gli altri membri del team lo vedono ancora come aperto.",
  note_placeholder: "Aggiungi contesto per il team…",
  notes_count: "{n} nota/e",
  device_detail: "Dettagli dispositivo",
  device_diagnostics: "Diagnostica",
  device_firmware_history: "Cronologia firmware",
  device_ota_config: "Configurazione OTA",
  device_ota_status: "Stato OTA",
  device_signal: "Qualità segnale",
  device_mac: "Indirizzo MAC",
  device_serial: "Numero di serie",
  fall_sensitivity: "Sensibilità caduta",
  transmission_interval: "Intervallo di trasmissione",
  low_battery_threshold: "Soglia batteria scarica",
  ota_idle: "Inattivo",
  ota_pending: "In attesa",
  ota_deploying: "In distribuzione",
  ota_failed: "Fallito",
  events_filter_severity: "Gravità",
  events_filter_room: "Stanza",
  events_filter_patient: "Paziente",
  events_filter_device: "Dispositivo",
  severity_info: "Info",
  severity_warning: "Avvertimento",
  severity_critical: "Critico",
  telegram_title: "Avvisi Telegram",
  telegram_desc: "Ricevi avvisi Telegram per i residenti a cui sei assegnato.",
  telegram_connect: "Collega Telegram",
  telegram_connected: "Telegram collegato",
  telegram_connected_as: "Collegato a Telegram come {name}",
  telegram_connect_success: "Telegram collegato con successo",
  telegram_connect_error: "Impossibile collegare Telegram. Riprova.",
  telegram_missing_bot: "Bot Telegram non configurato. Imposta REACT_APP_TELEGRAM_BOT nel file env.",
  telegram_disconnect: "Disconnetti",
  telegram_disconnect_success: "Telegram disconnesso.",
  telegram_disconnect_error: "Impossibile disconnettere Telegram. Riprova.",
  telegram_already_linked: "Questo account Telegram è già collegato a un altro utente e2-care.",
  telegram_switch_q: "Usare un altro account Telegram?",
  telegram_switch_intro: "Telegram ricorda quale account è connesso su tutti i siti web. Per usarne un altro:",
  telegram_switch_step1: "Apri Telegram Web ed esci dal tuo account attuale.",
  telegram_switch_step2: "Torna qui e ricarica il pulsante qui sotto, poi accedi con l’altro account.",
  telegram_open_web: "Apri Telegram Web",
  telegram_reload_widget: "Ho effettuato la disconnessione — ricarica il pulsante",
  lang_autodetected_toast: "Lingua rilevata: {language}. Puoi cambiarla nelle Impostazioni.",
  admin_view_active: "Attivi",
  admin_view_archived: "Archiviati",
  admin_restore: "Ripristina",
  admin_restored: "Ripristinato.",
  admin_hard_delete: "Elimina definitivamente",
  admin_hard_delete_title: "Eliminare definitivamente?",
  admin_hard_delete_confirm: "«{name}» sarà eliminato definitivamente dal database. L’azione non può essere annullata.",
  admin_hard_deleted: "Eliminato definitivamente.",
  admin_no_archived: "Nessun elemento archiviato.",
  language_desc: "Usata per l’interfaccia dell’app e per le tue notifiche Telegram + push.",
  language_saved: "Lingua aggiornata.",
  language_error: "Impossibile aggiornare la lingua. Riprova.",
  admin_field_language: "Lingua",
  edit: "Modifica",
  generic_error: "Qualcosa è andato storto. Riprova.",
  caregiver_added: "Assistente aggiunto.",
  caregiver_removed: "Assistente rimosso.",
  family_added: "Familiare aggiunto.",
  family_removed: "Familiare rimosso.",
  menu: "Menu",
  dl_companion_app: "App companion",
  dl_hero_title: "E2 Care per Android",
  dl_hero_sub: "Installa l’app companion su un telefono dotato di Moko per inoltrare gli avvisi, configurare i dispositivi e restare connesso al tuo team di assistenza, anche quando la dashboard è chiusa.",
  dl_android_apk: "APK Android",
  dl_version_loading: "caricamento versione…",
  dl_released: "Rilasciato il {date}",
  dl_download_apk: "Scarica APK",
  dl_unavailable: "Non disponibile",
  dl_preparing: "Preparazione…",
  dl_manifest_error: "Impossibile caricare il manifest. Prova ad aggiornare; se il problema persiste, il server di build potrebbe essere in fase di redistribuzione.",
  dl_whats_new: "Novità",
  dl_installing_title: "Installazione sul telefono",
  dl_step1: "Tocca «Scarica APK» qui sopra. Il browser potrebbe avvisare che i file APK possono danneggiare il dispositivo: è un avviso normale per qualsiasi installer scaricato al di fuori del Play Store.",
  dl_step2: "Apri il file scaricato. Android ti chiederà di consentire le installazioni da questo browser la prima volta: attiva l’autorizzazione e torna indietro.",
  dl_step3: "Tocca «Installa», poi «Apri» al termine.",
  dl_step4: "Accedi con le tue credenziali E2 Care.",
  dl_iphone_note: "La versione per iPhone arriverà più avanti. Per ora, usa la dashboard web.",
  dl_back_to_dashboard: "Torna alla dashboard",
  dl_android_min: "Android {version}+",
  admin_device_org_change_hint: "Cambiare organizzazione azzera l’assegnazione corrente di stanza e paziente.",
  admin_view_full: "Elenco completo",
  device_filter_assignment: "Assegnazione",
  device_filter_patient: "Assegnato a paziente",
  device_filter_room: "Assegnato a stanza",
  device_filter_unassigned: "Non assegnato",
  admin_all_orgs: "Tutte le organizzazioni",
  pagination_prev: "Precedente",
  pagination_next: "Successivo",
  pagination_per_page: "Per pagina",
  pagination_page_of: "Pagina {page} di {pages}",
  pagination_total: "{total} in totale",
};
export default it;
